import {
	DataHandlerDevice,
	DataHandlerFolder,
	DataHandlerMedia,
	ChargebeeMngr,
	DeviceSpotlightManager,
	Device,
} from "luxedo-data"

import { UserStore, getCurrentUser } from "../../stores/UserStore.svelte"
import { FileSystemMedia } from "../file-system/FileSystemMedia"
import { DeviceUpdateManager } from "../device-operation-managers/DeviceUpdateManager"
import { ProjectorPowerManager, DevicePlaybackManager } from "luxedo-data"
import { LuxedoRPC } from "luxedo-rpc"
import { InitPageLoader } from "luxedo-comps/auth"
import { CalibrationController } from "../../comps/reusable/overlays/calibration/CalibrationController.svelte"
import { parseSubscriptionParams } from "@entitlements/client"
import { entitlementsApi } from "../subscription-management/entitlementsApi"
import { POLL_INTERVAL_SLOW, POLL_INTERVAL_SLOW_DEV } from "luxedo-rpc/src/backend/consts"
import { getSubscriptionManager } from "../subscription-management/SubscriptionManager.svelte"
import { autoLinkLuxPlayDevice } from "../subscription-management/luxPlayManagement"

export const pageLoader = new InitPageLoader(import.meta.env.VITE_API_URL, UserStore.set)
export const ChargebeeManager = new ChargebeeMngr()

async function getTimetables() {
	const timetables = await LuxedoRPC.api.user.account_fetch_device_timetables()

	const devices = DataHandlerDevice.getMany()
	const mapped: { [index: string]: Device } = {}
	for (const dev of devices) {
		mapped[String(dev.id)] = dev
	}

	for (const [id, timetable] of Object.entries(timetables)) {
		mapped[id].timetableManager.handlePulledData(timetable)
	}
}

function checkForRunningCalibrations() {
	const allDevices = DataHandlerDevice.getMany()
	for (const dev of allDevices) {
		CalibrationController.checkForRunningCalibration(dev)
	}
}

async function checkForSubscriptions() {
	const params = parseSubscriptionParams(window.location.href)

	try {
		if (params) {
			await entitlementsApi.linkCustomerSubscription(
				`${getCurrentUser().id}`,
				params.id,
				params.email
			)

			try {
				// if this is a LuxPlay subscription,
				// this will be link the first lux play device under this account that is not active
				await autoLinkLuxPlayDevice(params.id)
			} catch (e) {
				console.error("Failed to auto link lux play devices (probably not a valid subscription)")
				console.error(e)
			}
		}

		await getSubscriptionManager().refreshUserSubscriptions()
	} catch (e) {
		console.error(e)
		console.error(`Failed to link subscription to user`, params)
	}
}

pageLoader.postInit(async () => {
	DataHandlerMedia.bindAlterEndpoints()
	await ChargebeeManager.pullPlans(getCurrentUser())
	DataHandlerFolder.calculateAllFolderStorage()
	FileSystemMedia.initialize()
	await getTimetables()
	DeviceUpdateManager.resetListeners()
	ProjectorPowerManager.initialize()
	DevicePlaybackManager.initialize()
	DeviceSpotlightManager.initialize()
	checkForRunningCalibrations()
	await checkForSubscriptions()

	LuxedoRPC.backend.startPolling(import.meta.env.PROD ? POLL_INTERVAL_SLOW : POLL_INTERVAL_SLOW_DEV)
	// SuperscaleProgressManager.initialize()
})
